import { createContext, useContext } from 'react';
import { SocialLoginDataType } from 'types/cookie';

export const SocialLoginDataContext = createContext<SocialLoginDataType | null>(null);

export function useSocialLoginDataContext(): SocialLoginDataType | null {
    return useContext(SocialLoginDataContext);
}
